export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/swooping-arrow-small.4c16b22f.svg","height":84,"width":104};